__turbopack_context__.v({
  "contributors": "osAjaq_contributors",
  "contributors__list": "osAjaq_contributors__list",
  "contributors__title": "osAjaq_contributors__title",
});
